import React from "react";
import { orderHeaderModel } from "../../../Interfaces";
import { MainLoader } from "../Common";
import OrderListProps from "./orderListType";
import { useNavigate } from "react-router-dom";
import { getStatusColor } from "../../../Helper";

function OrderList({ isLoading, orderData }: OrderListProps) {
  const navigate = useNavigate();
  return (
    <>
      {isLoading && <MainLoader />}
      {!isLoading && (
        <>
          <div className="table px-5 d-none d-md-block d-lg-block d-xl-block">
            <div className="p-2">
              <div className="row border">
                <div className="col-1">ID</div>
                <div className="col-2">Name</div>
                <div className="col-2">Phone</div>
                <div className="col-1">Total</div>
                <div className="col-1">Items</div>
                <div className="col-2">Date</div>
                <div className="col-2">Status</div>
                <div className="col-1"></div>
              </div>
              {orderData.map((orderItem: orderHeaderModel) => {
                const badgeColor = getStatusColor(orderItem.status!);
                return (
                  <div className="row border" key={orderItem.orderHeaderId}>
                    <div className="col-1">{orderItem.orderHeaderId}</div>
                    <div className="col-2">{orderItem.pickupName}</div>
                    <div className="col-2">{orderItem.pickupPhoneNumber}</div>
                    <div className="col-1">
                      &#x20b9; {orderItem.orderTotal!.toFixed(2)}
                    </div>
                    <div className="col-1">{orderItem.totalItems}</div>
                    <div className="col-2">
                      {orderItem.orderDate?.substring(0, 10)}
                    </div>
                    <div className="col-2">
                      <span className={`badge bg-${badgeColor}`}>
                        {orderItem.status}
                      </span>
                    </div>
                    <div className="col-1">
                      <button
                        className="btn btn-success"
                        onClick={() =>
                          navigate(
                            "/order/orderDetails/" + orderItem.orderHeaderId
                          )
                        }
                      >
                        Details
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="d-block d-md-none d-lg-none d-xl-none">
            <table className="table table-success table-bordered w-75 mx-auto">
              <tbody>
              {orderData.map((orderItem: orderHeaderModel) => {
                const badgeColor = getStatusColor(orderItem.status!);
                //const buttonColor = getStatusColor("success");
                return (
                  <>
                <tr key={orderItem.orderHeaderId}>
                  <th scope="row">ID</th>
                  <td>{orderItem.orderHeaderId}</td>
                </tr>
                <tr>
                <th scope="row">Name</th>
                <td>{orderItem.pickupName}</td>
                </tr>
                <tr>
                <th scope="row">Phone</th>
                <td>{orderItem.pickupPhoneNumber}</td>
                </tr>
                <tr>
                <th scope="row">Total</th>
                <td>&#x20b9; {orderItem.orderTotal!.toFixed(2)}</td>
                </tr>
                <tr>
                <th scope="row">Items</th>
                <td>{orderItem.totalItems}</td>
                </tr>
                <tr>
                <th scope="row">Date</th>
                <td>{orderItem.orderDate?.substring(0, 10)}</td>
                </tr>
                <tr>
                <th scope="row">Status</th>
                <td><span onClick={() =>
                          navigate(
                            "/order/orderDetails/" + orderItem.orderHeaderId
                          )
                        } className={`badge bg-${badgeColor}`}>
                        {orderItem.status}
                      </span></td>
                </tr>
              </>
                 );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </>
  );
}

export default OrderList;
